function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.18,2.82H3.79a1,1,0,0,0-1,1V18.74a1,1,0,0,0,1,1H20.18a1,1,0,0,0,1-1V3.82A1,1,0,0,0,20.18,2.82Zm-.4,15.52H4.2V4.23H19.78Zm-5.165-7.993a.935.935,0,1,0,.939.935.937.937,0,0,0-.939-.935Zm0,0M7.3,16.186a.667.667,0,0,1-.667-.666V7.043a.667.667,0,0,1,1.333,0V15.52A.666.666,0,0,1,7.3,16.186ZM20.99,0H3.01A3.011,3.011,0,0,0,0,3V19.5a3,3,0,0,0,2.42,2.94v.89a.665.665,0,1,0,1.33,0V22.5H19.79v.83a.665.665,0,1,0,1.33,0v-.84A3,3,0,0,0,24,19.5V3A3.011,3.011,0,0,0,20.99,0Zm1.72,19.5a1.72,1.72,0,0,1-1.72,1.72H3.01A1.72,1.72,0,0,1,1.29,19.5V3A1.72,1.72,0,0,1,3.01,1.28H20.99A1.72,1.72,0,0,1,22.71,3Zm-8.094-4.4a3.822,3.822,0,1,1,3.827-3.821A3.829,3.829,0,0,1,14.616,15.1Zm0-6.152a2.331,2.331,0,1,0,2.334,2.331A2.336,2.336,0,0,0,14.616,8.951Z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/other_assets.f7cf7a2b.svg";
export { SvgComponent as ReactComponent };